module.exports = __webpack_public_path__ + "static/media/luftkvalitet_icon_about_hvit.6c19f434.svg";